var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"margin-right":"5px"}},[_c('el-button',{attrs:{"type":"danger","size":_vm.btnSize,"icon":"el-icon-delete"},on:{"click":function($event){return _vm.deleteConfirm()}}},[_vm._v("Del")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }